import React, { useState, useRef } from "react";
import Swal from "sweetalert2";
import { uploadBackgroundImage } from "../apis/backgroundImagesApi";

const BackgroundUploadModal = ({ onUpload, onClose }) => {
  const [file, setFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const fileInputRef = useRef(null); // Ref for the file input

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    // Validate file type
    const validTypes = ["image/jpeg", "image/png", "image/gif"];
    if (!validTypes.includes(selectedFile.type)) {
      Swal.fire("Error", "Please select a valid image (JPEG, PNG, GIF)", "error");
      e.target.value = null;
      return;
    }

    // Validate file size (50MB)
    if (selectedFile.size > 50 * 1024 * 1024) {
      Swal.fire("Error", "Please select an image under 50MB", "error");
      e.target.value = null;
      return;
    }

    setFile(selectedFile);
    setPreviewUrl(URL.createObjectURL(selectedFile));
  };

  const resetForm = () => {
    setFile(null);
    setPreviewUrl(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // Clear the file input safely
    }
  };

  const handleUpload = async () => {
    if (!file) {
      Swal.fire("Error", "Please select a file to upload", "error");
      return;
    }

    setIsUploading(true);
    try {
      const response = await uploadBackgroundImage(file);
      console.log("Uploaded image URL in BackgroundUploadModal:", response); // Log the URL
      resetForm(); // Reset the form before calling onUpload
      onUpload(response); // Pass the full URL to BackgroundSelector, which will re-fetch backgrounds
      Swal.fire("Success", "Background uploaded successfully", "success");
    } catch (error) {
      console.error("Upload error:", error);
      Swal.fire(
        "Error",
        `Failed to upload background: ${error.message}`,
        "error"
      );
    } finally {
      setIsUploading(false);
    }
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1100,
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          padding: "30px",
          borderRadius: "15px",
          boxShadow: "0 0 15px rgba(0, 0, 0, 0.3)",
          width: "400px",
          maxWidth: "90%",
        }}
      >
        <h3
          style={{
            fontSize: "1.5rem",
            fontWeight: "600",
            color: "#1f2937",
            textAlign: "center",
            marginBottom: "20px",
          }}
        >
          Upload New Background
        </h3>
        <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
          <input
            id="file-input"
            type="file"
            ref={fileInputRef}
            onChange={handleFileChange}
            accept="image/jpeg,image/png,image/gif"
            style={{
              padding: "5px",
              border: "2px solid #541AC9",
              borderRadius: "8px",
              width: "100%",
              boxSizing: "border-box",
              margin: "0",
            }}
          />
          {previewUrl && (
            <img
              src={previewUrl}
              alt="Preview"
              style={{
                width: "100%",
                maxHeight: "200px",
                objectFit: "cover",
                borderRadius: "8px",
                margin: "10px 0",
              }}
              onError={() => console.log("Failed to load preview")}
            />
          )}
          <div
            style={{ display: "flex", gap: "15px", justifyContent: "center" }}
          >
            <button
              onClick={handleUpload}
              disabled={isUploading}
              style={{
                padding: "10px 20px",
                backgroundColor: isUploading ? "#d1d5db" : "#10b981",
                color: "#fff",
                border: "none",
                borderRadius: "8px",
                cursor: isUploading ? "not-allowed" : "pointer",
                transition: "background-color 0.2s ease",
              }}
              onMouseOver={(e) => {
                if (!isUploading) e.target.style.backgroundColor = "#059669";
              }}
              onMouseOut={(e) => {
                if (!isUploading) e.target.style.backgroundColor = "#10b981";
              }}
            >
              {isUploading ? "Uploading..." : "Upload"}
            </button>
            <button
              onClick={handleClose}
              style={{
                padding: "10px 20px",
                backgroundColor: "#dc2626",
                color: "#fff",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
                transition: "background-color 0.2s ease",
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = "#b91c1c")}
              onMouseOut={(e) => (e.target.style.backgroundColor = "#dc2626")}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BackgroundUploadModal;